// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
/* eslint-disable @typescript-eslint/naming-convention */
export const MAX_EXT_ATTRIBUTES = 50;
export const UTM_PREFIX = 'utm_';
